// Formatters for time saved (COF-591). Every figure is an estimate, so each
// one rounds down, the same rule as the API and the student client's
// formatSaved. Ratios arrive already floored to one decimal by the API.
// Callers gate on the time saved block, so undefined is never passed; null
// means there is no figure yet.

const NONE_YET = 'None yet';

const whole = (n) => { return Math.floor(n).toLocaleString('en-US'); };

/** "45m", "6h 40m", and whole hours from 100 hours ("112h"). */
export const fmtSaved = (minutes) => {
  if (minutes === null || minutes === undefined) { return NONE_YET; }
  const total = Math.floor(minutes);
  const hours = Math.floor(total / 60);
  if (hours === 0) { return `${total}m`; }
  if (hours >= 100) { return `${whole(hours)}h`; }
  return `${hours}h ${total % 60}m`;
};

/**
 * A per-student share of `totalMinutes`. A share that floors to 0 while the
 * total is above 0 (1h across 186 students) reads "Under 1m", not "0m".
 */
export const fmtSavedShare = (minutes, totalMinutes) => {
  if (minutes !== null && minutes !== undefined && Math.floor(minutes) === 0 && totalMinutes > 0) { return 'Under 1m'; }
  return fmtSaved(minutes);
};

/** Whole hours: "3,506h". */
export const fmtHours = (minutes) => {
  if (minutes === null || minutes === undefined) { return NONE_YET; }
  return `${whole(minutes / 60)}h`;
};

/** The value of saved time in whole dollars: "$12,807". */
export const fmtValue = (cents) => {
  if (cents === null || cents === undefined) { return 'N/A'; }
  return `$${whole(cents / 100)}`;
};

/** The assumed hourly value, as the API states it: "$15", "$30.93". */
export const fmtHourly = (cents) => {
  return cents % 100 === 0 ? `$${cents / 100}` : `$${(cents / 100).toFixed(2)}`;
};

/** Value per $1 of a cost: "$31.2". */
export const fmtPerDollar = (ratio) => {
  return ratio === null || ratio === undefined ? 'N/A' : `$${ratio}`;
};

/** A student's value over what their Pro cost: "10.3x". */
export const fmtMultiple = (ratio) => {
  return ratio === null || ratio === undefined ? 'N/A' : `${ratio}x`;
};
